import {AnyLicence, CertificateVehicleLicence} from '..';

export const isCertificateVehicleLicence = (licence: AnyLicence): licence is CertificateVehicleLicence => {
  const validLicenceIds = ['certificateVehicleLicence3Year', 'certificateVehicleLicence7Day'];
  return validLicenceIds.includes((licence as CertificateVehicleLicence).licence_type_id);
}